import { useEffect } from "react";

/**
 * Runs an effect after a delay when dependencies change (debounced effect).
 * @param {() => void} fn - Effect function to run
 * @param {number} waitTime - Debounce delay in ms
 * @param {React.DependencyList} deps - Dependency array
 */
export function useDebounceEffect(fn, waitTime, deps) {
  useEffect(() => {
    const t = setTimeout(() => {
      fn();
    }, waitTime);
    return () => clearTimeout(t);
    // fn, waitTime, and deps are the hook's API; deps is dynamic so we cannot use a static array literal
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fn, waitTime, ...deps]);
}
